/**
 * Static routes + blurbs included in client-side site search (About, Contact, policies, etc.).
 */

export const SITE_SEARCH_STATIC_PAGES = [
  {
    title: 'About Our Fiddle Music Shop',
    route: '/about',
    content: `Welcome to the Fiddle Music Shop, your number one source for all things fiddle! We're dedicated to giving you the very best of fiddle music resources, with a focus on quality, customer service, and uniqueness. Founded in 2025, our shop has come a long way from its beginnings. When we first started out, our passion for preserving and sharing the rich tradition of fiddle music drove us to do intense research, and gave us the impetus to turn hard work and inspiration into to a booming online store. We now serve customers all over the world, and are thrilled to be a part of the quirky, eco-friendly, fair trade wing of the music industry. We hope you enjoy our products as much as we enjoy offering them to you. If you have any questions or comments, please don't hesitate to contact us.`,
  },
  {
    title: 'Contact Us',
    route: '/contact',
    content: `Contact Cranford Publications: cranfordpub@gmail.com or 1-902-929-2391. Cape Breton, Nova Scotia.`,
  },
  {
    title: 'FAQ - Frequently Asked Questions',
    route: '/faq',
    content: `Frequently Asked Questions about our Celtic fiddle music shop. Find answers to common questions about ordering, shipping, products, payment methods, and more. Learn about our Celtic music collection, fiddle books, tune collections, and digital downloads.`,
  },
  {
    title: 'Shipping Policy',
    route: '/shipping-policy',
    content: `Shipping policy and delivery information. Learn about our shipping rates, delivery times, international shipping options, tracking information, and shipping methods. We ship Celtic fiddle music books and products worldwide.`,
  },
  {
    title: 'Return Policy',
    route: '/return-policy',
    content: `Return and refund policy. Information about returns, refunds, exchanges, and our satisfaction guarantee. Learn about our return process, eligibility requirements, and how to return products.`,
  },
  {
    title: 'Privacy Policy',
    route: '/privacy-policy',
    content: `Privacy policy and data protection information. Learn how we collect, use, and protect your personal information. Details about cookies, data security, and your privacy rights.`,
  },
  {
    title: 'Terms of Use',
    route: '/terms-of-use',
    content: `Terms of use and conditions for using our website. Legal terms, user responsibilities, intellectual property rights, and service conditions for Cranford Publications.`,
  },
];
